export class API {
  static login = "api/login";
  static getPositionTreeView = "api/getPositionTreeView";
  static getMasters = "api/getMasters";
  static getNewOTP = "api/getNewOTP";
  static changePassword = "api/changePassword";
  static getUserSessions = "api/getUserSessions";
  static getUserLogs = "api/getUserLogs";
  static getActualTourPlan = "api/getActualTourPlan";
  static getTourPlan = "api/getTourPlan";
  static getTeamAttendance = "api/getTeamAttendance";
  static getAllowedMonths = "api/getAllowedMonths";
  static getEffortReport = "api/getEffortReport";
  static getDarReport = "api/getDarReport";
  static getMasReport = "api/getMasReport";
  static getOvpReport = "api/getOvpReport";
  static sendPushNotification = "api/sendPushNotification";
  static getEmployeeInfo = "api/getEmployeeInfo";
  static UpdateEmployeeDetails = "api/UpdateEmployeeDetails";
  static unlockAccount = "api/UnlockEmpAccount";
  static UnlockDays = "api/UnlockDays";
  static getEmployeeAttendance = "api/getEmployeeAttendance";
  static getEmployees = "api/getEmployees";
  static getFtpImportBatches = "api/getFtpImportBatches";
  static getFtpExportBatches = "api/getFtpExportBatches";
  static getFtpImportLogs = "api/getFtpImportLogs";
  static getFtpExportLogs = "api/getFtpExportLogs";
  static getActivityKpis = "api/getActivityKpis";
  static getTeamMtpStatus = "api/getTeamMtpStatus";
  static getRequestedMTPByPosition = "api/getRequestedMTPByPosition";
  static getMtpByIdV2 = "api/getMtpByIdV2";
  static approveMTP = "api/approveMTP";
  static rejectMTP = "api/rejectMTP";
  static pendingLeaveCountList = "api/pendingLeaveCountList";
  static getEmployeeLeave = "api/getEmployeeLeave";
  static getLeaveStatus = "api/getLeaveStatus";
  static leaveApprove = "api/leaveApprove";
  static leaveReject = "api/leaveReject";
  static getMyTeam = "api/getMyTeam";
  static expenseOverview = "api/expenseOverview";
  static empDateWiseExpense = "api/empDateWiseExpense";
  static getExpensesNew = "api/getExpensesNew";
  static getStatus = "api/getStatus";
  static getExpensesMaster = "api/getExpensesMaster";
  static editApprovalExpenses = "api/editApprovelExpenses";
  static getWorkingDays = "api/getWorkingDays";
  static expensesApproved = "api/expensesApproved";
  static deleteExpenseList = "api/deleteExpenseList";
  static getExpenseListDetails = "api/getExpenseListDetails";
  static getExpenseLastDates = "api/getExpenseLastDates";
  static getProfile = "api/getProfile";
  static getSGPIBalance = "api/getSGPIBalance";
  static getOutletTypes = "api/getOutletTypes";
  static getEmployeeLeave = "api/getEmployeeLeave";
  static getEmployeeLeaveBalance = "api/getEmployeeLeaveBalance";
  static getSgpiOutReport = "api/getSgpiOutReport";
  static getRcpaSkuSummary = "api/getRcpaSkuSummary";
  static getPodReport = "api/getPodReport";
  static getJwReport = "api/getJwReport";
  static getExpensesSummary = "api/getExpensesSummary";
  static getExpenseStatus = "api/getExpenseStatus";
  static pendingAdminLeaveCountList = "api/pendingAdminLeaveCountList";
  static getMtpDayById = "api/getMtpDayById";
}
